import React, { useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, Checkbox, Button } from '@mui/material';
import { useStateContext } from '../contexts/ContextProvider'
import styled from '@emotion/styled'
import { deleteEmail } from '../utils/connect'

const Container = styled(Paper)({

    display: 'flex',
    flexDirection: 'column',
    padding: '15px',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
    borderRadius: '10px',
    width: '90%',  
    height: '64%'
})

function MultiEmailSelector() {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const { sendData, setSendData, sendFilter, setEmailPaneVisible, setToEditId, setLastMethod } = useStateContext();

    const filteredData = sendData.filter(item =>
        (!sendFilter.name || item.name.toLowerCase().includes(sendFilter.name.toLowerCase())) &&
        (!sendFilter.company || item.company.toLowerCase().includes(sendFilter.company.toLowerCase())) &&
        (!sendFilter.status || item.status.toLowerCase().includes(sendFilter.status.toLowerCase()))
    );

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // 判断是否所有行都已选中
    const isAllSelected = () => sendData.filter(item => item.toSend === true).length === sendData.length;
    // 切换所有行的选中状态
const toggleSelectAll = () => {
    if (isAllSelected()) {
        const updatedData = sendData.map(item => {
            if (item.status !== 'Sent') {
                return { ...item, toSend: false };
            }
            return item;
        });
            setSendData(updatedData);
        } else {
            const updatedData = sendData.map(item => ({ ...item, toSend: true }));
            setSendData(updatedData);
    }
};

    // 切换单个行的选中状态
    const toggleSelect = (index) => {
        const updatedData = sendData.map((item, i) => {
            if(index === i) {
                return ({...item, toSend: !item.toSend})
            }
            else {
                return item
            }
        });
        setSendData(updatedData);
    };

    const handleEdit = (index) => {
        setEmailPaneVisible(true);
        setToEditId(index); 
        setLastMethod("Edit");
    }

    const handleDelete = (index) => {
        setSendData(sendData.filter(item => item.id !== index))
        deleteEmail(index)
    }

    return (
        <Container>
            <TableContainer component={Paper} style={{ height: '400px' }}>
            <Table stickyHeader>
                <TableHead>
                <TableRow>
                    <TableCell>
                    <Checkbox
                        checked={isAllSelected()}
                        onChange={toggleSelectAll}
                    />
                    </TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Company</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Business Match Meeting</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell />
                </TableRow>
                </TableHead>
                <TableBody>
                    {filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                    <TableRow key={index}
                        style={{
                            backgroundColor: row.status === 'Error' ? '#FDE5EC' : 
                                            row.status === 'Sent' ? '#C8FFE0' : 'transparent'
                        }}
                    >
                        <TableCell>
                        <Checkbox
                            checked={row.toSend}
                            onChange={() => toggleSelect(page * rowsPerPage + index)}
                            disabled={row.status === 'Sent' ? true : false}
                        />
                        </TableCell>
                        <TableCell>{row.name}</TableCell>
                        <TableCell>{row.company}</TableCell>
                        <TableCell>{row.email}</TableCell>
                        <TableCell>{row.business_matching_meeting}</TableCell>
                        <TableCell>{row.status}</TableCell>
                        <TableCell>
                            <Button onClick={() => handleEdit(row.id)}>
                                Edit
                            </Button>
                            <Button style={{"color":"#F31559"}} onClick={() => handleDelete(row.id)}>
                                Delete
                            </Button>
                        </TableCell>
                    </TableRow>
                    ))}
                </TableBody>
            </Table>
            </TableContainer>
            <div style={{display:"flex",flexDirection:"row", justifyContent:"space-between"}}>
                <div style={{marginTop:"15px", display:"flex", flexDirection:"row"}}>
                    <div style={{marginRight:"10px"}}>
                    Not sent: {sendData.filter(item => item.status === "Not sent").length}
                    </div>
                    <div style={{marginRight:"10px"}}>
                    Sent: {sendData.filter(item => item.status === "Sent").length}
                    </div>
                    <div style={{marginRight:"10px"}}>
                    Error: {sendData.filter(item => item.status === "Error").length}
                    </div>
                </div>
            <TablePagination
                style={{ overflow: 'hidden' }} 
                rowsPerPageOptions={[10, 20, 40]}
                component="div"
                count={filteredData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
            </div>
        </Container>
    );
}

export default MultiEmailSelector;
